import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import plus from "../../../Components/Admin/assets/icons/a1.png";
import colunms from "../../../Components/Admin/assets/icons/LINES.png";
import search1 from "../../../Components/Admin/assets/icons/search.png";
import top from "../../../Components/Admin/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModalDelete";
import {
  AddButton,
  EditButton,
  DeletButton,
  Submit,
} from "../../common/Button";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ScreenShot from "../../common/ScreenShot";
import Users from "./Users";
import Reports from "./Reports";
import ExportMethod from "../../../utils/apis/ExportMethod";
import { formatDate, IDS } from "../../../utils/common";
// import { Context } from "../../../utils/context";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "../../common/common-offcanvas/Filter_offcanvas";
import { getSetup } from "../../../utils/apis/masters/masters";
import { getDownloadDataExcel } from "../../../utils/api";
import { AcceptBulkCanceled } from "../../../utils/apis/Canceled/Canceled";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  const [setup, setSetup] = useState({});
  const getsetup = async () => {
    const res = await getSetup();
    await setSetup(res?.data);
  };

  useEffect(() => {
    getsetup();
  }, []);
  const convertrate = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup?.withdraw_exchange_rate || 0);
    const total = (inr * rate).toFixed(2);
    return total;
  };

  // hok form
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  // table
  const { IMG_URL, isAllow } = useContext(Context);
  const [modalShow, setModalShow] = useState(false);

  const [status, setStatus] = useState();

  const handleExportCSV = (data, file) => {
    const header = [
      { name: "ID" },
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "State" },
      { name: "District" },
      { name: "A/C No" },
      { name: "IFSC Code" },
      { name: "Withdrawal Amount USD" },
      { name: "Withdrawal Amount Rupees" },
      { name: "Bank Charges USD" },
      { name: "Bank Charges Rupees" },
      { name: "Status" },
      { name: "Customer Cancel Status" },
      { name: "Payment Type" },
    ];
    const exportData = data?.data?.map((data) => [
      data.id,
      formatDate(data.createdAt),
      data?.user?.f_name,
      data?.user?.contact_no,
      data?.user?.users_detail?.state?.name,
      data?.user?.users_detail?.city?.name,
      data?.ac_no,
      data?.ifsc_code,
      data?.amount,
      convertrate(Number(data?.amount)),
      data?.bank_charges,
      convertrate(data?.bank_charges),
      data?.accepted_rejected === null
        ? ""
        : data?.accepted_rejected
          ? "Accepted"
          : "Rejected",
      IDS.customer_status[data?.customer_status],
      data?.withdrawn_type,
    ]);
    const { content, type, name } = ExportMethod.csv(exportData, header, file);
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const handleExportExcel = (data, file) => {
    // console.log(data);
    const header = [
      { name: "ID" },
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "State" },
      { name: "District" },
      { name: "A/C No" },
      { name: "IFSC Code" },
      { name: "Withdrawal Amount USD" },
      { name: "Withdrawal Amount Rupees" },
      { name: "Bank Charges USD" },
      { name: "Bank Charges Rupees" },
      { name: "Status" },
      { name: "Customer Cancel Status" },
      { name: "Payment Type" },
    ];
    // console.log(data?.data, "data?.data data?.data");

    const exportData = data?.data?.map((data) => [
      data.id,
      formatDate(data.createdAt),
      data?.user?.f_name,
      data?.user?.contact_no,
      data?.user?.users_detail?.state?.name,
      data?.user?.users_detail?.city?.name,
      // data?.ac_no?.toString(),
      "'" + data?.ac_no?.toString() + "'",
      data?.ifsc_code,
      data?.amount,
      convertrate(Number(data?.amount)),
      data?.bank_charges,
      convertrate(data?.bank_charges),
      data?.accepted_rejected === null
        ? ""
        : data?.accepted_rejected
          ? "Accepted"
          : "Rejected",
      IDS.customer_status[data?.customer_status],
      data?.withdrawn_type,
    ]);

    // console.log(exportData);
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      file,
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const handlePrint = (data, file) => {
    const header = [
      { name: "ID" },
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "State" },
      { name: "District" },
      { name: "A/C No" },
      { name: "IFSC Code" },
      { name: "Withdrawal Amount USD" },
      { name: "Withdrawal Amount Rupees" },
      { name: "Bank Charges USD" },
      { name: "Bank Charges Rupees" },
      { name: "Status" },
      { name: "Customer Cancel Status" },
      { name: "Payment Type" },
    ];
    const exportData = data?.data?.map((data) => [
      data.id,
      formatDate(data.createdAt),
      data?.user?.f_name,
      data?.user?.contact_no,
      data?.user?.users_detail?.state?.name,
      data?.user?.users_detail?.city?.name,
      data?.ac_no,
      data?.ifsc_code,
      data?.amount,
      convertrate(Number(data?.amount)),
      data?.bank_charges,
      convertrate(data?.bank_charges),
      data?.accepted_rejected === null
        ? ""
        : data?.accepted_rejected
          ? "Accepted"
          : "Rejected",
      IDS.customer_status[data?.customer_status],
      data?.withdrawn_type,
    ]);
    const content = ExportMethod.print(exportData, header);
    const printWindow = window.open("", "_blank");
    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.print();
  };

  const [modalShow2, setModalShow2] = React.useState(false);

  //

  const navigate = useNavigate();

  const DownloadSample = async (e) => {
    await getDownloadDataExcel(
      "/payment/outward-payment/outward-sample-download",
      null,
      "Canceled Bulk Accept Sample sheet",
    );
  };

  // const onSubmit = async (data) => {
  //   // alert(JSON.stringify(data));

  //   const formData = new FormData();
  //   formData.append("file", data.excel[0]);

  //   const res = await AcceptBulkCanceled(formData);
  //   if (res.success) {
  //     alert("Accept Bulk Outword SuccessFull...!");
  //     navigate("/outward");
  //     reset();
  //   } else {
  //     alert("Something went wrong...!");
  //   }
  // };
  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Canceled Payment"} link={"/outward"} />

        {/* <div className="card-body p-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row align-items-end">
             
              <div className="col-md-6">
                <div className="form-group">
                  <label>Upload Excel Sheet</label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".xls,.xlsx"
                    {...register("excel", {
                      required: "Excel file is required",
                    })}
                  />
                  {errors.excel && (
                    <small className="text-danger">
                      {errors.excel.message}
                    </small>
                  )}
                </div>
              </div>

              <div className="col-md-3">
                <label className="d-block">&nbsp;</label>
               
                <button
                  onClick={DownloadSample}
                  type="button"
                  // variant="danger"
                  className="btn btn-outline-primary w-100"
                >
                  Download Sample Sheet
                </button>
              </div>

              <div className="col-md-3">
                <label className="d-block">&nbsp;</label>
                <button type="submit" className="btn btn-success w-100">
                  Upload
                </button>
              </div>
            </div>
          </form>
        </div> */}

        {/* <div className="investor-main"><div></div>
          <div className="filterdiv mt-4 me-3">
            <button onClick={() => setModalShow2(true)} className="filterbtn">
              <FontAwesomeIcon icon={faFilter} />
              &nbsp;Filter
            </button>
          </div>
        </div> */}

        {isAllow?.includes(40) ? (
          <Users
            isAllow={isAllow}
            status={status}
            setStatus={setStatus}
            handleExportCSV={handleExportCSV}
            handlePrint={handlePrint}
            handleExportExcel={handleExportExcel}
            convertrate={convertrate}
          />
        ) : (
          <></>
        )}

        {isAllow?.includes(41) ? (
          <Reports
            isAllow={isAllow}
            status={status}
            setStatus={setStatus}
            handleExportCSV={handleExportCSV}
            handlePrint={handlePrint}
            handleExportExcel={handleExportExcel}
            convertrate={convertrate}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Tables;
